import React from "react";
import Layout from "../../components/Layout/Layout";

const Complaints = () => {
    return (
        <Layout>
            <section className="page-hero">
                <div className="container">
                    <div className="eyebrow">
                        <span className="dot"></span> Complaints Handling
                    </div>
                    <h1>Complaints Handling</h1>
                    <p>
                        We are committed to providing a high standard of service. If you are dissatisfied with any aspect of our
                        services, you have the right to submit a complaint and have it handled in a fair, consistent, and timely
                        manner.
                    </p>
                </div>
            </section>

            <section className="section section-tight">
                <div className="container grid-2">
                    <article className="card">
                        <span className="kicker">How to submit a complaint</span>
                        <h2>Contact channels</h2>
                        <p>You may submit a complaint by contacting us via:</p>
                        <p className="small-muted" style={{ marginTop: 8 }}>Other channels:</p>
                        <ul className="check-list micro-list">
                            <li>
                                Email:{" "}
                                <a href="mailto:kelly@everest.org" style={{ color: "var(--brand)" }}>
                                    kelly@everest.org
                                </a>
                            </li>
                            <li>
                                By post to:<br />
                                Everest Network Ltd.<br />
                                Tower Business Centre 2nd floor, TRIQ IT- TORRI, SWATAR BIRKIRKARA, BKR 4013, Malta
                            </li>
                            <li>
                                Via this website{" "}
                                <a href="https://static-assets.everest.org/web/files/complaints_policy.pdf" style={{ color: "var(--brand)" }}>
                                    complaint template
                                </a>{" "}
                                (Annex A of the complaint policy)
                            </li>
                            <li>Via Customer support channels</li>
                        </ul>
                        <p style={{ marginTop: 12 }}>To help us process your complaint efficiently, please include:</p>
                        <ul className="check-list micro-list">
                            <li>your full name and contact details</li>
                            <li>your account information (if applicable)</li>
                            <li>a clear description of the issue</li>
                            <li>any relevant supporting documentation</li>
                        </ul>
                    </article>

                    <article className="card">
                        <span className="kicker">Our complaints process</span>
                        <h2>How we handle complaints</h2>
                        <ul className="check-list micro-list">
                            <li>All complaints are handled in accordance with our internal procedures.</li>
                            <li>Complaints are assessed objectively and independently.</li>
                            <li>We may contact you for further information where required.</li>
                            <li>We will keep you informed of the progress of your complaint where appropriate.</li>
                        </ul>
                        <h3 style={{ marginTop: 18 }}>Response timeframes</h3>
                        <ul className="check-list micro-list">
                            <li>We aim to resolve complaints as promptly as possible.</li>
                            <li>You will receive an acknowledgement of your complaint.</li>
                            <li>We will provide a response within 15 days.</li>
                            <li>
                                Where additional time is required, we will inform you and provide an updated timeframe.
                            </li>
                        </ul>
                        <h3 style={{ marginTop: 18 }}>Escalation</h3>
                        <ul className="check-list micro-list">
                            <li>
                                If you are not satisfied with our response, you may have the right to escalate your complaint to
                                the relevant regulatory authority or dispute resolution body.
                            </li>
                            <li>Details of escalation options will be provided in our final response.</li>
                        </ul>
                    </article>

                    <article className="card" style={{ gridColumn: "1 / -1" }}>
                        <span className="kicker">Further information</span>
                        <h2>Policy and additional details</h2>
                        <p>
                            For full details on how we handle complaints, please refer to our{" "}
                            <a href="https://static-assets.everest.org/web/files/complaints_policy.pdf" target="_blank" style={{ color: "var(--brand)" }}>
                                Complaints Handling Policy
                            </a>
                            .
                        </p>
                    </article>
                </div>
            </section>
        </Layout>
    );
};

export default Complaints;
